import product from '#frontend/singleDataLayer/shared/product.js';

/**
 * User added products into order
 * @param {object} cart Cart object with all the data
 * @param {Array} addedProducts Array of added products
 * @returns {object} Object for Single Data Layer
 */
export default (cart, addedProducts) => {
	const productsObject = {
		user: {
			add: {
				products: []
			}
		},
		order: {
			products: []
		},
		event: 'user.add.products'
	};
	// Add added products into object (cart.order.impressions)
	if (Array.isArray(addedProducts) && addedProducts.length) {
		addedProducts.forEach((productData) => {
			// Add to order
			productsObject.order.products.push(product(productData, cart.order));
			// Add to added products
			productsObject.user.add.products.push(product(productData, cart.order));
		});
	}
	// All the products in the order
	if (Array.isArray(cart.order.products) && cart.order.products.length) {
		cart.order.products.forEach((productData) => {
			productsObject.order.products.push(product(productData, cart.order));
		});
	}

	return productsObject;
};
